export default __webpack_public_path__ + "static/media/affiliate.f60086a9.png";